import Qs from 'qs'
import axios, { AxiosInstance } from 'axios'
import BaseConfig from '@/utils/config'

import Store from '@/store'

const httpInstance: AxiosInstance = axios.create({
    baseURL: BaseConfig.HTTP_URL,
    timeout: 10000
})
httpInstance.interceptors.request.use(
    config => {
        return config
    },
    error => {
        return Promise.reject(error)
    }
)
httpInstance.interceptors.response.use(
    response => {
        return response.data ? response.data : response
    }, error => {
        return Promise.reject(error)
    }
)

const activityInstance: AxiosInstance = axios.create({
    baseURL: BaseConfig.ACTIVITY_URL,
    timeout: 10000
})
activityInstance.interceptors.request.use(
    config => {
        return config
    },
    error => {
        return Promise.reject(error)
    }
)
activityInstance.interceptors.response.use(
    response => {
        return response.data ? response.data : response
    }, error => {
        return Promise.reject(error)
    }
)

export function $http(url: string, params: any, method: string = 'post') {
    return new Promise((resolve, reject) => {
        httpInstance[method](url, method === 'post' ? params : {
            params
        }).then((res: any) => {
            if (res && (res.status == 0 || res.status == 200)) {
                resolve(res.data ? res.data : res)
            } else {
                reject(res)
            }
        }).catch(() => {
            reject()
        })
    })
}

export function $request(url: string, params: any, method: string = 'get') {
    return new Promise((resolve, reject) => {
        activityInstance[method](url, method == 'get' ? {
            params
        } : params).then((res: any) => {
            if (res && res.errno == 0) {
                resolve(res.data ? res.data : res)
            } else if (res && res.errno == 1250) {
                Store.commit('SET_DIALOGDATA', {
                    text: '绑定微信后才能拆现金红包哦！',
                    subText: '现金将存入你的微信红包',
                    btns: [
                        {
                            text: '取消',
                            className: 'close-btn'
                        },
                        {
                            text: '确定',
                            className: 'wxAuthorize-btn'
                        }
                    ]
                })
                reject(res)
            } else if (res && res.errno == 1010) {
                const data = res.data
                const captcha = new window.TencentCaptcha(`${data.appid}`, (ret: any) => {
                    activityInstance.post('/captcha/user', {
                        type: data.type,
                        ticket: ret.ticket,
                        randstr: ret.randstr,
                        userinfo: Store.state.userInfo
                    })
                })
                captcha.show()
                reject(res)
            } else {
                reject(res)
            }
        }).catch(() => {
            reject()
        })
    })
}
